import styled from '@emotion/styled';
import React, { useState } from 'react';

import { TextButton, Text } from '../../atoms';
import { TextField } from '../../molecules';
import Modal from '../Modal';
import theme from '../../../styles/theme';
import useForm from '../../../hooks/useForm';
import { useUserContext } from '../../../contexts/UserContext';
import { usePostContext } from '../../../contexts/PostContext';

const InputForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.xl};
`;

const ChangeName = () => {
  const {
    user: { id },
    handleName,
  } = useUserContext();
  const { handleChangeUsername } = usePostContext();

  const [modalVisible, setModalVisible] = useState(false);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const { values, errors, isLoading, handleChange, handleSubmit } = useForm({
    initialValue: {
      fullName: '',
    },
    onSubmit: async (values) => {
      const changeName = await handleName({
        fullName: values.fullName,
        username: values.fullName,
      });

      if (changeName) {
        handleChangeUsername({ userId: id, username: values.fullName });
        openModal();
      }
    },
    validate: ({ fullName }) => {
      const errors = {};

      if (!fullName) {
        errors.fullName = '닉네임을 입력해주세요.';
      } else if (!/^[가-힣]+$/.test(fullName)) {
        errors.fullName =
          '닉네임은 초성이 아닌 한글로 입력해주세요. 공백은 허용되지 않습니다.';
      }
      // else if (handleName.status) {
      //   errors.fullName = '이름이 이미 사용중이에요.';
      // }

      return errors;
    },
  });
  return (
    <InputForm onSubmit={handleSubmit}>
      <TextField
        name="fullName"
        type="text"
        isFullWidth
        label="닉네임"
        placeholder="변경할 닉네임을 입력해주세요."
        onChange={handleChange}
        error={errors.fullName}
        value={values.fullName}
      />
      {errors.fullName ? (
        <Text
          size="xs"
          color={theme.colors.error}
          style={{ textAlign: 'right' }}
        >
          {errors.fullName}
        </Text>
      ) : null}
      <TextButton
        type="submit"
        disabled={isLoading}
        style={{ marginLeft: 'auto' }}
      >
        변경
      </TextButton>
      <Modal visible={modalVisible} onClose={closeModal}>
        닉네임이 성공적으로 변경되었어요.
      </Modal>
    </InputForm>
  );
};

export default ChangeName;
